import * as React from 'react'
import {Editable} from '../Data/Editable'
import RaisedButton from 'material-ui/RaisedButton'
import EditorModeEdit from 'material-ui/svg-icons/editor/mode-edit'
import ContentClear from 'material-ui/svg-icons/content/clear'
import CircularProgress from 'material-ui/CircularProgress'
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh'
import IconButton from 'material-ui/IconButton'
import creiosTheme from '../Theme/creiosTheme'
import NavigationCheck from 'material-ui/svg-icons/navigation/check'

export function EditableButtons<T>({editable, onEdit, onSave, onDiscard}: {
    editable: Editable<T>,
    onEdit: () => void,
    onSave: () => void,
    onDiscard: () => void,
}) {
    switch (editable.type) {
        case 'Locked':
            return (
                <IconButton
                    onTouchTap={onEdit}
                >
                    <EditorModeEdit/>
                </IconButton>)
        case 'Pending':
            return (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <IconButton
                        style={{marginRight: '10px'}}
                        onTouchTap={onDiscard}
                    >
                        <ContentClear color={creiosTheme.palette.errorColor}/>
                    </IconButton>
                    <IconButton
                        onTouchTap={onSave}
                    >
                        <NavigationCheck color={creiosTheme.palette.successColor}/>
                    </IconButton>
                </div>)
        case 'Loading':
            return <CircularProgress size={24}/>
        case 'Failure':
            return (
                <div>
                    <span style={{marginRight: '10px'}}>Error</span>
                    <RaisedButton
                        primary={true}
                        icon={<NavigationRefresh/>}
                        className="btn-icon"
                        style={{marginRight: '10px'}}
                        onTouchTap={onSave}
                    />
                </div>)
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/EditableButtons.tsx